import { Link } from 'react-router-dom';
import SetupProgress from './SetupProgress';

export default function SetupShell({
  step,
  children,
  footerShowBack = false,
  onFooterBack,
  footerRight,
}) {
  return (
    <div className="min-h-screen bg-theme-main text-theme-text flex flex-col">
      <header className="px-6 py-5 border-b border-theme-secondary/60">
        <div className="max-w-2xl mx-auto flex items-center justify-between">
          <Link to="/" className="text-xl font-semibold text-theme-primary">
            os-router
          </Link>
          <Link to="/" className="text-sm opacity-50 hover:opacity-80 transition-opacity">
            Exit setup
          </Link>
        </div>
      </header>

      <main className="flex-1 px-6 py-10">
        <div className="max-w-2xl mx-auto">
          <SetupProgress step={step} />
          <div className="mt-8">{children}</div>
        </div>
      </main>

      <footer className="sticky bottom-0 border-t border-theme-secondary bg-theme-main/95 backdrop-blur px-6 py-5">
          <div className="max-w-2xl mx-auto grid grid-cols-3 items-center gap-4">
            <div className="flex justify-start">
              {footerShowBack && (
                <button
                  type="button"
                  onClick={onFooterBack}
                  className="px-4 py-2 rounded-lg border border-theme-secondary text-sm hover:bg-theme-secondary/30 transition-colors"
                >
                  Back
                </button>
              )}
            </div>
            <div />
            <div className="flex justify-end">{footerRight}</div>
          </div>
        </footer>
    </div>
  );
}
